import React from 'react';
import { useTranslation } from 'react-i18next';
import { DollarSign } from 'lucide-react';
import { DataTable } from './UIComponents';
import { formatNumber } from './formatters';

const StockFinancials = ({ data }) => {
  const { t } = useTranslation();
  const financialData = [
    { label: t('stocks.fields.revenueTtm'), value: formatNumber(data.revenue, '$') },
    { label: t('stocks.fields.revenueGrowthYoy'), value: '--' },
    { label: t('stocks.fields.grossProfitTtm'), value: formatNumber(data.grossProfit, '$') },
    { label: t('stocks.fields.operatingIncomeTtm'), value: formatNumber(data.operatingIncome, '$') },
    { label: t('stocks.fields.netIncomeTtm'), value: formatNumber(data.netIncome, '$') },
    { label: t('stocks.fields.earningsGrowthYoy'), value: '--' },
    { label: t('stocks.fields.currentAssetsMrq'), value: formatNumber(data.currentAssets, '$') },
    { label: t('stocks.fields.totalLiabilitiesMrq'), value: formatNumber(data.liabilities, '$') },
    { label: t('stocks.fields.totalAssetsMrq'), value: formatNumber(data.assets, '$') },
    { label: t('stocks.fields.totalEquityMrq'), value: formatNumber(data.equity, '$') },
    { label: t('stocks.fields.freeCashFlowTtm'), value: '--' },
    { label: t('stocks.fields.operatingCashFlowTtm'), value: '--' },
  ];

  return (
    <div className="space-y-8">
      <DataTable
        title={t('stocks.tableTitles.financialStatements')}
        icon={DollarSign}
        data={financialData}
        defaultExpanded={true}
      />
    </div>
  );
};

export default StockFinancials;